<template>
  <div class="user-profile box">
    <div class="profile-data flex m-a-start">
      <h3 class="profile-data__info flex profile-name">{{user.display_name}} <small class="user-id profile-id">-{{ user.id }}-</small></h3>
      <p class="profile-data__info profile-email">{{ user.email }}</p>
      <p class="profile-data__info profile-link"><a target="blank" :href="`https://open.spotify.com/user/${user.id}/`">Link to profile</a></p>
    </div>
  </div>    
</template>

<script>

export default {
  name: 'userProfile',
  props: ['user']
}
</script>

<style scoped>
  .user-profile {
    margin: 2rem;
    padding: 1rem;
  }

  .user-id {
    font-size: .8rem;
    color: #666e98;
  }

  .profile-name,
  .profile-email,
  .profile-id,
  .profile-link {
    width: 100%;
    text-align: left;
  }
  @media screen and (max-width: 1024px) { 
    .user-profile {
      width: 100%;
    }
  }
</style>